export enum LocaleEnum {
    English = 'en',
    Spanish = 'es'
}
